<template>
  <output v-if="text" class="round-clock" :class="{ banner }">{{ text }}</output>
</template>

<script setup lang="ts">
import { computed, onUnmounted, ref } from 'vue'
import { useI18n } from '../i18n/t'

const props = defineProps<{
  endsAt: string
  banner?: boolean
}>()

const { t } = useI18n()
const now = ref(Date.now())
const timer = setInterval(() => {
  now.value = Date.now()
}, 1000)

onUnmounted(() => {
  clearInterval(timer)
})

const text = computed(() => {
  const ends = Date.parse(props.endsAt)
  if (!Number.isFinite(ends)) return ''
  const left = Math.max(0, Math.ceil((ends - now.value) / 1000))
  const minutes = Math.floor(left / 60)
  const seconds = left % 60
  const clock = `${minutes}:${String(seconds).padStart(2, '0')}`
  return t('tournament.roundClock', { time: clock })
})
</script>

<style scoped>
.round-clock {
  display: block;
  margin: -4px 0 8px;
  font-size: 13px;
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  color: var(--md-sys-color-on-surface-variant);
}

.round-clock.banner {
  position: absolute;
  top: 8px;
  left: 50%;
  z-index: 40;
  margin: 0;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(12, 14, 24, 0.88);
  color: #fde68a;
  font-size: 14px;
  letter-spacing: 0.02em;
  pointer-events: none;
  transform: translateX(-50%);
}
</style>
